import { wordEnding } from '@shared/lib';

export default wordEnding;